export default "__VITE_PUBLIC_ASSET__514a0fed__"